<template>
  <div>
    <v-container class="pa-2">
      <v-toolbar rounded dark>
        <v-toolbar-title>Carrinho de Compras</v-toolbar-title>
        <v-spacer />
        <v-badge bordered color="error" :content="$store.state.produtos.length" overlap>
          <v-icon>mdi-cart</v-icon>
        </v-badge>
      </v-toolbar>

      <v-divider></v-divider>

      <v-col
        v-if="$store.state.produtos.length === 0"
        class="px-4 py-8 text-center"
      >Seu carrinho de compras está vazio</v-col>

      <v-virtual-scroll
        v-else
        :items="$store.state.produtos"
        :item-height="96"
        :height="windowHeight"
      >
        <template v-slot="{ item, index }">
          <v-col cols="12" class="pt-1 pb-2">
            <v-card>
              <div class="d-flex flex-no-wrap">
                <div style="width: 100%; overflow: hidden; white-space: nowrap">
                  <v-card-title
                    class="headline pt-2 pb-3"
                    v-text="item.descricao"
                    style="text-overflow: ellipsis; overflow: hidden; display: block; font-size: 1.2rem !important"
                  />
                  <v-card-subtitle
                    class="py-0"
                    style="font-size: 0.8rem; font-weight: 300"
                  >Código - {{item.id}}</v-card-subtitle>

                  <v-card-subtitle class="pb-2 pt-1">
                    <span>{{item.quantidade}}</span> x
                    <span>R$ {{item.valor | valorBR}}</span>
                    <span
                      style="background-color: dimgrey; color: white; border-radius: 4px; padding: 0px 4px; margin-left: 6px"
                    >R$ {{item.subtotal | valorBR}}</span>
                  </v-card-subtitle>
                </div>

                <v-list-item-icon class="mr-4 my-auto">
                  <v-btn fab depressed small @click="$store.commit('removerItemCarrinho', index)">
                    <v-icon color="red">mdi-cart-remove</v-icon>
                  </v-btn>
                </v-list-item-icon>

                <v-avatar class="ma-3" size="68" tile @click="abrirGrade(item)">
                  <v-img
                    :src="item.fotos[0]"
                    style="border-radius: 4px; border: 1px solid #eee; cursor: pointer"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
        </template>
      </v-virtual-scroll>

      <v-col class="pt-2 pb-0">
        <v-row>
          <v-col
            class="py-2"
            cols="12"
            style="display: flex; align-items: center; justify-content: flex-end"
          >
            <v-chip class="ma-0" label style="width: 100%; display: grid">
              <span class="mr-auto">Itens: </span>
              <span> {{$store.state.produtos.length}}</span>
            </v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="py-2"
            cols="12"
            style="display: flex; align-items: center; justify-content: flex-end"
          >
            <v-chip class="ma-0" color="primary" label style="width: 100%; display: grid">
              <span class="mr-auto">Total</span>
              <h1>R$ {{ valorTotal | valorBR}}</h1>
            </v-chip>
          </v-col>
        </v-row>
      </v-col>

      <v-col class="py-1">
        <v-btn depressed block @click="fecharDrawer">Continuar Comprando</v-btn>
      </v-col>
      <v-col flex v-if="$store.state.produtos.length > 0">
        <v-btn depressed dark block @click="finalizarCompra">Finalizar Compra</v-btn>
      </v-col>
    </v-container>

    <v-overlay opacity="1" :value="overlay" z-index="5">
      <div
        style="background-color: white; border-radius: 50%; width: 180px; height: 180px; display: flex; align-items: center; justify-content: center"
      >
        <img src="@/assets/namoda.svg" class="ml-2" style="max-height: 128px" />
      </div>
    </v-overlay>

    <grade ref="grade" idWindow="d" />
  </div>
</template>

<script>
import Grade from "./Grade.vue";

export default {
  props: {
    update: Boolean,
    fecharDrawer: Function,
  },
  components: { Grade },
  data() {
    return {
      overlay: false,
      windowHeight: window.innerHeight,
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight =
        window.innerHeight - (this.$vuetify.breakpoint.xsOnly ? 310 : 270);
    });
  },
  methods: {
    login() {
      this.$emit("abrirLoginCarrinho");
    },
    finalizarCompra() {
      this.fecharDrawer(true);
      if (this.$auth.check()) {
        this.$router.push("/checkout");
      } else {
        this.login();
      }
    },
    abrirGrade(produto) {
      this.$refs.grade.abrir(produto);
    },
  },
  watch: {
    update: function (value) {
      if (value) {
        document.querySelector("html").style.overflowY = "hidden";
      } else {
        document.querySelector("html").style.overflowY = "auto";
      }
    },
  },
  computed: {
    valorTotal() {
      return this.$store.state.produtos.reduce((soma, produto_atual) => {
        return produto_atual.subtotal + soma;
      }, 0);
    },
  },
};
</script>